export default __webpack_public_path__ + "6776c2ae72d750d40f19c82accdc0f1f.jpg";